import { general } from './general';
import { textarea } from './textarea';
import { text } from './text';
import { branch } from './branch';
import { daterange } from './daterange';
import { notapplicable } from './notapplicable';
import { location } from './location';

export const sentence = (data = {}) => general('sentence', {
  Description: textarea(data?.Description),
  ExceedsYear: branch(data?.ExceedsYear),
  Incarcerated: branch(data?.Incarcerated),
  IncarcerationDates: daterange(data?.IncarcerationDates),
  IncarcerationDatesNA: notapplicable(data?.IncarcerationDatesNA),
  ProbationDates: daterange(data?.ProbationDates),
  ProbationDatesNA: notapplicable(data?.ProbationDatesNA),
  IncarcerationFacility: text(data?.IncarcerationFacility), // PVQ Only
  IncarcerationFacilityAddress: location(data?.IncarcerationFacilityAddress), // PVQ Only
  GrantedParole: branch(data?.GrantedParole), // PVQ Only
  GrantedParoleDates: daterange(data?.GrantedParoleDates), // PVQ Only

});
